
import { useState,  useEffect } from 'react';

import { AxiosRequestConfig } from "axios";
import Request from '@ywfe/request';
// @ts-ignore
import * as querystring from 'querystring';
// @ts-ignore
import { ParsedUrlQueryInput } from 'querystring';
// @ts-ignore
import * as R from 'ramda';
import {configs} from './config';


  const projectId = "PROAUTH";
  let env;
  if(typeof window === 'undefined'){
    env = (process.env.REACT_APP_ENV === 'prod' ? 'prod': process.env.REACT_APP_ENV) || 'prod';
  } else {
    env = window.localStorage.getItem('env') || (process.env.REACT_APP_ENV === 'prod' ? 'prod': process.env.REACT_APP_ENV) || 'prod';
  }
  
  const basePath = configs[projectId][env].API_BASE_URL + `${env === 'mock' ? '/' + 88 : ''}`;
  

// @ts-ignore
const parseParams = <T>(params: T) => {
  return R.values<any, any>(params).join('/');
}



export interface UserSendmtcodeInput {
  
    
    /** 手机号 */
    telephone?: string;
  
    
    /** REGISTER RESET_PWD OLD_PHONE NEW_PHONE WX_BIND MANAGER_BANKCARD ADD_ALIPAY_ACCOUNT ACCOUNT_AUTHENTICATION */
    codeType?: string;
  
}

export interface UserSendmtcodeData {
  
}

// 19969 发送手机号码验证码

  export const usePostUserSendmtcode = () => {
    let isMount = true;
    const [isUserSendmtcodeLoading, setIsUserSendmtcodeLoading] = useState(false);
    const [dataUserSendmtcode, setDataUserSendmtcode] = useState<UserSendmtcodeData>({} as UserSendmtcodeData);
    const postUserSendmtcodeData = async(params: UserSendmtcodeInput, config?: AxiosRequestConfig): Promise<UserSendmtcodeData> => {
      if(isMount){
        setIsUserSendmtcodeLoading(true);
      }
      
      try{
        
          
          
          const res: any = await Request.post<UserSendmtcodeData>(`${basePath}/user/sendMtCode`, params, config);
          
          
          if(isMount){
            setDataUserSendmtcode(res || {});
            setIsUserSendmtcodeLoading(false);
          }
          return res;
      } catch(error){
        console.log(error);
        if(isMount){
          setIsUserSendmtcodeLoading(false);
        }
        return false as unknown as UserSendmtcodeData;
      }
      
    }

    useEffect(() => {
      return () => {
        isMount = false;
      };
    }, []);
  
    return {
      isUserSendmtcodeLoading,
      dataUserSendmtcode,
      postUserSendmtcodeData,
    }
  }

